import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import * as Highcharts from 'highcharts';
import { Options } from 'highcharts';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TranslaterService } from 'src/app/services/translater.service';

@Component({
  selector: 'app-genealogy-dashboard',
  templateUrl: './genealogy-dashboard.component.html',
  styleUrls: ['./genealogy-dashboard.component.scss']
})
export class GenealogyDashboardComponent implements OnInit {

  breadcrumList: any = [];
  options!: Options;
  chartOutputLossWaterfall!: any;
  arr = [
    //   {
    //   name: 'Jumbo',
    //   y: 2000,
    //   color: '#2f7ed8'
    // }, {
    //   name: 'Winder',
    //   y: 4000,
    //   color: '#0d233a'
    // }, {
    //   name: 'Sheeter',
    //   y: 6000,
    //   color: '#77a1e5'
    // }, {
    //   name: 'Reker',
    //   y: 8000,
    //   color: '#a6c96a'
    // },
    //  {
    //   name: 'Balance',
    //   isSum: true,
    //   color: Highcharts.getOptions().colors[1]
    // }
  ]
  colors = ['#2f7ed8', '#0d233a', '#77a1e5', '#a6c96a']
  gridApi: any;
  gridColumnApi: any;
  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
  }
  ColumnDefs = [
    { field: 'BatchNo', headerName: 'Batch No' },
    { field: 'PU_Desc', headerName: 'Machine' },
    { field: 'Result', headerName: 'Quantity' }
  ];
  paginationPageSize: any = 10;
  rowData: any = [
    // { BatchNo: 'Pulp-16jun', PU_Desc: 'PM - Pope Reel', Result: '16.0' },
    // { BatchNo: 'Jumbo-250-P01-10-107-0003', PU_Desc: 'PM - Pope Reel', Result: '10.0' }
  ];
  barCode: string;
  IsAccess: any;
  IsWrite: any;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;

  constructor(private commonService: CommonService, private cd: ChangeDetectorRef, private kpiMaster: KpimasterService, private usermanagementService: UserManagementService, private toaster: ToastrService, public translate: TranslateService, public translater: TranslaterService) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();})
  }

  ngOnInit(): void {
    this.GetBreadcrumList();
    this.GetMenuAccess();
  }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  GetMenuAccess() {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.kpiMaster.GetMenuAccess(key).subscribe((data: any) => {
      // this.permisson = data;
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;
    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId: localStorage.getItem('O3RightMenuId') === null ? 1 : localStorage.getItem('O3RightMenuId')
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe((data: any) => {
      this.breadcrumList = data.BreadcrumList;
      this.moduleId = this.breadcrumList[0].id;
      this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
      this.getLangWords();
      console.log(data.BreadcrumList);
    }, (error) => {
      this.toaster.error('Error', error.ErrorMessage);
    });
  }

  productionOutputByBarcode() {
    const data = { "barcode": this.barCode }
    this.commonService.productionOutputByBarcode(data).subscribe((res: any) => {
      if (res) {
        // this.barCode = '';
        this.rowData = res.data;
        this.rowData = this.rowData.sort((a, b) => a.BI_Id > b.BI_Id ? -1 : 1);
        const ind = this.rowData.findIndex(val => val.BatchNo == this.barCode);
        this.rowData = this.rowData.slice(ind);
        this.arr = [];
        this.rowData.forEach((val, index) => {
          this.arr.push({ name: val.BatchNo, y: val.Result, color: this.colors[index] });
        })
        this.waterfallMonthlyOutputLoss();
        this.cd.detectChanges();
      }
    }, err => {
      console.log(err)
    })
  }

  waterfallMonthlyOutputLoss() {
    Highcharts.chart('container', {
      chart: {
        type: 'waterfall'
      },

      title: {
        text: 'Highcharts Waterfall'
      },

      xAxis: {
        type: 'category'
      },

      yAxis: {
        title: {
          text: 'QTY'
        }
      },

      legend: {
        enabled: false
      },

      tooltip: {
        pointFormat: '<b>{point.y:,.2f}</b>'
      },

      series: [{
        upColor: Highcharts.getOptions().colors[2],
        color: Highcharts.getOptions().colors[3],
        data: this.arr,
        dataLabels: {
          enabled: true,
          formatter: function () {
            return Highcharts.numberFormat(this.y / 10000, 0, ',');
          },
          style: {
            fontWeight: 'bold'
          }
        },
        pointPadding: 0
      }]
    } as any);
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridOptions.api.sizeColumnsToFit();
  }

}
